module.exports = __webpack_public_path__ + "ce394ea72ed4ae94a14f0ef6a7e31c07.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/lazy-5.png
// module id = 2143
// module chunks = 0